import { app } from "$src/components/app";

app.init();